<template>
  <div>
    <div v-if="isExistSearchResult">
      <table id="data-table" class="table table-striped table-hover">
        <thead>
          <tr>
            <th scope="col">企業コード</th>
            <th scope="col">企業名</th>
            <th scope="col">拠点コード</th>
            <th scope="col">拠点名称</th>
            <th scope="col">ユーザID</th>
            <th scope="col">ユーザ名称</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="value in userList" :key="value.enterpriseCode + value.userId">
            <td class="table-cell-wrap mw150 mxw150" scope="row">{{ value.enterpriseCode }}</td>
            <td class="table-cell-wrap mw200 mxw200">{{ value.enterpriseName }}</td>
            <td class="table-cell-wrap mw150 mxw150">{{ value.sectionCode }}</td>
            <td class="table-cell-wrap mw200 mxw200">{{ value.sectionName }}</td>
            <th class="table-cell-wrap mw150 mxw200">
              <router-link :to="{ name: 'user-edit', params: { mode: 'update', enterpriseCode: value.enterpriseCode, sectionCode: value.sectionCode, userId: value.userId }}">
                {{ value.userId }}
              </router-link>
            </th>
            <td class="table-cell-wrap mw200 mxw200">{{ value.userName }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-else>
      検索結果は0件です。
    </div>
  </div>
</template>

<script>
export default {
  name: 'user-search-result',
  props: {
    userList: Array,
    isExistSearchResult: false
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>



// WEBPACK FOOTER //
// src/components/pages/UserSearchResult.vue